const FloorPlanOptionViewer = () => {
  const floorplanContainer = document.getElementById('js-floor-plan-images');
  const floorplanOptionBtns = document.querySelectorAll<HTMLButtonElement>(
    '.js-floor-plan-option',
  );
  if (!floorplanContainer || !floorplanOptionBtns) {
    return;
  }

  const loadImage = async (floorplanUrl: string) => {
    //load ajax stuff here
    floorplanContainer.style.filter = 'blur(5px)';

    try {
      // Perform the fetch operation
      const response = await fetch(floorplanUrl);

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const htmlContent = await response.text(); // Get HTML as a string
      // Process the fetched data and update the panel content
      floorplanContainer.innerHTML = htmlContent; // Example: setting content from fetched data
    } catch (error) {
      console.error('Failed to load content:', error);
    } finally {
      floorplanContainer.style.filter = 'none';
    }
  };

  const deactivateAllButtons = () => {
    floorplanOptionBtns.forEach(button => {
      button.classList.remove('active'); // Remove the active class from all buttons
    });
  };

  const handleButtonClick = (event: Event) => {
    event.preventDefault();
    const floorplanBtn = event.target as HTMLButtonElement;

    if (floorplanBtn.classList.contains('active')) {
      return; // Exit if the clicked button is already active
    }

    const floorplanUrl = floorplanBtn.dataset.target;

    if (floorplanUrl) {
      deactivateAllButtons(); // Remove the active class from all buttons
      floorplanBtn.classList.add('active'); // Add the active class to the clicked button
      loadImage(floorplanUrl); // Toggle the panel associated with the clicked button
    }
  };

  const init = () => {
    floorplanOptionBtns.forEach(floorplanOptionBtn => {
      floorplanOptionBtn.addEventListener('click', handleButtonClick);
    });
  };

  init();
};

export default FloorPlanOptionViewer;
